export enum CountryCode {
    NotSet = 0,
    Cyprus = 196,
    France = 250,
    Germany = 276,
    Gibraltar = 292,
    Greece = 300,
    Ireland = 372,
    Italy = 380,
    Singapore = 702,
    SouthAfrica = 710,
    Spain = 724,
    Thailand = 764,
    UAE = 784,
    Turkey = 792,
    Portugal = 620,
    UK = 826,
    Guernsey = 831,
    Jersey = 832,
    IsleOfMan = 833,
}